import { SvrConn } from "../utils/axios/index";

/**
 *
 */
const getDispensaAll = async () => {
    let res = {};
    try {
      res = await SvrConn.get("/api/dispensa/getdispensaall");
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
 *  Buscar Los Dispensadores por area sin importar el estado
 */
const getDispensaAllxArea = async (AreaId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/dispensa/getdispensaallarea",{AreaId});
    } catch (Error) {
      res = Error;
    }
    return res;
  };

/**
 *  Buscar Los Dispensadores por area y por Id
 */

  const getDispensaInt = async (DispensaId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/dispensa/getdispensaint",{DispensaId});
    } catch (Error) {
      res = Error;
    }
    return res;
  };

  /**
 * metodo para actualizar dispensador
 */
const actualizaDispensa = async (data) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/dispensa/setactualizadispensa", data);
    } catch (Error) {
      res = Error;
    }
    return res;
  };
  /**
   * 
  */
  const setBloqueaDispensa = async (areaId, dispensaId, TagId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/dispensa/setbloqueadispensa", { areaId, dispensaId,TagId });
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
 * 
 */
const setDesvinculaDispensa = async (areaId, dispensaId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/dispensa/setdesvinculadispensa", { areaId, dispensaId });
  } catch (Error) {
    res = Error;
  }
  return res;
};
  export {
    getDispensaAll,
    getDispensaAllxArea,
    getDispensaInt,
    actualizaDispensa,
    setBloqueaDispensa,
    setDesvinculaDispensa,
  };
  
  